import axiosClient from '@/config/api/axios'
import { AUTH_CATALOG_EXCHANGE } from '@/config/api/endpoints'

/** POST /api/auth/catalog/exchange — redeem Catalog ?code= for product JWT */
export async function exchangeCatalogCode(code) {
  const { data } = await axiosClient.post(AUTH_CATALOG_EXCHANGE, { code })
  return data
}
